import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { actions } from "store/actions";
import ProjectFilters from "pages/projects/common/ProjectFilters";
import Pagination from "components/pagination";
import DeliverablesPanel from "pages/projects/common/DeliverablesPanel";
import ReferenceFilesPanel from "pages/projects/common/ReferenceFilesPanel";
import ProjectsTable from "./components/ProjectsTable";
import useAgencyProjects from "./hooks/useAgencyProjects";

function AgencyProjects() {
  const [t] = useTranslation();

  const {
    searchTerm,
    setSearchTerm,

    selectedServices,
    setSelectedServices,
    selectedDeadline,
    setSelectedDeadline,
    serviceOptions,
    projects,
    totalCount,
    isLoading,
    pagination,
    setFilterQuery,
    handlePageChange,
    clearFilters,
    fetchProjects,
  } = useAgencyProjects();

  const [activeProject, setActiveProject] = React.useState(null);
  const [isDeliverablesOpen, setDeliverablesOpen] = React.useState(false);
  const [isReferencesOpen, setReferencesOpen] = React.useState(false);

  const dispatch = useDispatch();

  return (
    <div className="flex w-full h-full p-[24px] flex-col gap-[20px] self-stretch flex-1">
      <div className="flex items-center gap-[12px]">
        <div className="text-[#1D1B22] font-semibold text-[30px]">
          {t("agencyTitle")}
        </div>

        <div className="flex py-[4px] p-[8px] justify-center items-center gap-[2px] rounded-[6px] border border-[#B5C8D6] bg-[#E0E6EB]">
          <div className="text-[#1E4A6B] font-semibold text-[14px] h-[20px]">
            {totalCount}
          </div>
        </div>
      </div>

      <ProjectFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedServices={selectedServices}
        setSelectedServices={setSelectedServices}
        selectedDeadline={selectedDeadline}
        setSelectedDeadline={setSelectedDeadline}
        setFilterQuery={setFilterQuery}
        serviceOptions={serviceOptions}
        // disabled={!projects || projects.length === 0}
      />

      {/* Projects Table */}
      <ProjectsTable
        fetchProjects={fetchProjects}
        projects={projects}
        isLoading={isLoading}
        viewReferences={(p) => {
          setActiveProject(p);
          setReferencesOpen(true);
        }}
      />

      <DeliverablesPanel
        isOpen={isDeliverablesOpen}
        onClose={() => setDeliverablesOpen(false)}
        files={activeProject?.deliverables || []}
        onUpload={(uploaded) => {
          dispatch(
            actions.uploadDeliverable(
              { projectId: activeProject?.id, fileId: uploaded.fileId },
              (success) => {
                if (success) {
                  // Optionally refresh list or project; hook already fetches on filter changes
                }
              }
            )
          );
        }}
      />

      <ReferenceFilesPanel
        isOpen={isReferencesOpen}
        onClose={() => setReferencesOpen(false)}
        files={activeProject?.referenceFile || []}
      />

      {totalCount > pagination.pageSize && (
        <div className="flex justify-end items-end w-full h-full">
          <Pagination
            currentPage={pagination.pageNumber}
            totalPages={Math.ceil(totalCount / pagination.pageSize)}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
}

export default AgencyProjects;
